module.exports = __webpack_public_path__ + "static/media/imageUp.58aae062.gif";